import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { formatPrice } from "../utils/format";

function Cart(props) {

    const navigate = useNavigate();
    const [freeDelivery, setFreeDelivery] = useState(false);
    const [totalProducts, setTotalProducts] = useState(null);
    const [total, setTotal] = useState(null);

    useEffect(() => {
        let total_quantity = 0;
        let total_amount_cart = 0;
        for (let i = 0; i < props.cart.length; i++) {
            total_quantity += props.cart[i].quantity;
            total_amount_cart += props.cart[i].total;
        }
        setTotalProducts(total_amount_cart);

        if (total_quantity === 1 && !props.discountAlertRendered) {
            alert(`¡Despacho gratis en compras mayores a ${formatPrice(process.env.REACT_APP_FREE_DELIVERY_AMOUNT)}!`);
            props.setDiscountAlertRendered(true);
        }

        if (total_amount_cart >= Number(process.env.REACT_APP_FREE_DELIVERY_AMOUNT)) {
            setTotal(total_amount_cart);
            setFreeDelivery(true);
        } else {
            setTotal(total_amount_cart + Number(process.env.REACT_APP_DELIVERY_FEE));
            setFreeDelivery(false);
        }
    }, [props.cart]);

    function handleClickContinue(event) {
        event.preventDefault();
        let total_quantity = 0;
        for (let i = 0; i < props.cart.length; i++) {
            total_quantity += props.cart[i].quantity;
        }
        if (total_quantity < 1) {
            alert("No tienes productos seleccionados");
            return;
        } else if (total_quantity < 1) {
            alert("Compra mínima de 1 unidad, selecciona un producto");
            return;
        }
        navigate("/date");
    }


    return (
        <div className="mx-3 rounded-2xl overflow-hidden bg-white border border-gray-100 shadow-sm">

            {/* Header */}
            <div className="px-4 py-3 flex items-center gap-2 border-b border-gray-100 bg-[#f7f4ef]">
                <svg className="w-4 h-4 text-[#a02338] flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
                </svg>
                <p className="text-sm font-semibold text-[#2a1419]">Tu pedido</p>
                {props.cart.length > 0 && (
                    <span className="ml-auto text-[11px] text-[#a02338] font-semibold bg-[#fbedef] px-2.5 py-0.5 rounded-full">
                        {props.cart.length} {props.cart.length === 1 ? "producto" : "productos"}
                    </span>
                )}
            </div>

            {props.cart.length > 0 ? (
                <>
                    {/* Items */}
                    <div className="divide-y divide-gray-50">
                        {props.cart.map((item) => (
                            <div key={item.product.id} className="flex items-center px-4 py-2.5 gap-3">
                                <div className="w-9 h-9 rounded-xl bg-[#faf1f2] flex items-center justify-center flex-shrink-0 overflow-hidden">
                                    {item.product.imageUrl ? (
                                        <img
                                            src={item.product.imageUrl}
                                            alt={item.product.name}
                                            className="w-full h-full object-contain p-1"
                                        />
                                    ) : (
                                        <span className="text-sm">🍓</span>
                                    )}
                                </div>
                                <div className="flex-1 min-w-0">
                                    <p className="text-[13px] font-medium text-[#2a1419] truncate">{item.product.name}</p>
                                    <p className="text-[11px] text-gray-400">{item.quantity} × {item.product.type}</p>
                                </div>
                                <p className="text-[13px] font-semibold text-[#2a1419] flex-shrink-0">
                                    {formatPrice(item.total)}
                                </p>
                            </div>
                        ))}
                    </div>

                    {/* Totales */}
                    <div className="px-4 py-3 border-t border-gray-100 bg-[#f7f4ef] flex flex-col gap-2">
                        <div className="flex justify-between items-center">
                            <span className="text-xs text-gray-400">Subtotal productos</span>
                            <span className="text-xs text-gray-600 font-medium">{formatPrice(totalProducts)}</span>
                        </div>
                        <div className="flex justify-between items-center">
                            <span className="text-xs text-gray-400">Despacho</span>
                            {freeDelivery ? (
                                <span className="text-[11px] font-semibold text-[#a02338] bg-[#fbedef] px-2 py-0.5 rounded-full">
                                    Gratis ✓
                                </span>
                            ) : (
                                <span className="text-xs text-gray-600 font-medium">
                                    {formatPrice(process.env.REACT_APP_DELIVERY_FEE)}
                                </span>
                            )}
                        </div>
                        <div className="flex justify-between items-center pt-2 border-t border-gray-200 mt-1">
                            <span className="text-[13px] font-semibold text-[#2a1419]">Total a pagar</span>
                            <span className="text-[16px] font-bold text-[#8c1d2f]">{formatPrice(total)}</span>
                        </div>
                    </div>
                </>
            ) : (
                <div className="px-4 py-8 flex flex-col items-center gap-2 text-center">
                    <div className="w-12 h-12 rounded-full bg-[#faf1f2] flex items-center justify-center text-2xl">
                        🛒
                    </div>
                    <p className="text-sm text-gray-400 mt-1">Agrega productos para comenzar</p>
                </div>
            )}

            {/* Botón continuar */}
            <div className="px-4 py-3 border-t border-gray-100">
                <button
                    onClick={handleClickContinue}
                    disabled={props.disabled}
                    className={`
                        w-full py-3 rounded-xl text-sm font-semibold transition-all duration-150
                        ${props.disabled
                            ? "bg-gray-100 text-gray-300 cursor-not-allowed"
                            : "bg-[#8c1d2f] hover:bg-[#a82a42] active:scale-[0.98] text-[#f5f0e8] shadow-md shadow-[#8c1d2f]/20"
                        }
                    `}
                >
                    {props.disabled ? "Selecciona tus productos" : "Continuar →"}
                </button>
            </div>
        </div>
    );
}

export default Cart;